export const firebaseConfig = {
    apiKey: "AIzaSyBD_kBMKYuaiVbP_O8d4nm1vVGGtWFoZNI",
    authDomain: "auth.goertzensonthego.com",
    databaseURL: "https://goertzensonthego.firebaseio.com",
    projectId: "goertzensonthego",
    storageBucket: "goertzensonthego.appspot.com",
    messagingSenderId: "696043264490",
    appId: "1:696043264490:web:4b20e1e07ed75e5f"
};